import { TextInput } from 'components/inputs/textInput';
import accountDataStyles from './AccountData.module.scss';
export type AccountDataLabel = {
  labelName: string;
  labelSurname: string;
  labelFiscalCode: string;
  labelEmail: string;
  labelTelephone: string;
  labelAddress: string;
  labelProvince: string;
  labelCity: string;
  labelZipCode: string;
};
export type AccountDataProps = {
  name: string;
  labelName: string;
  surname: string;
  labelsurname: string;
  //TODO: temporary fix (optional prop) for happybet
  fiscalCode?: string;
  labelFiscalCode: string;
  email: string;
  labelEmail: string;
  telephone: string;
  labelTelephone: string;
  address: string;
  labelAddress: string;
  //TODO: temporary fix (optional prop) for happybet
  province?: string;
  labelProvince: string;
  city: string;
  labelCity: string;
  zipCode: string;
  labelZipCode: string;
};
export const AccountData = ({ ...props }: AccountDataProps) => {
  return (
    <div className={accountDataStyles.container}>
      <TextInput name="name" disabled={true} value={props.name} label={props.labelName} />
      <TextInput name="surname" disabled={true} value={props.surname} label={props.labelsurname} />
      <TextInput name="fiscalcode" disabled={true} value={props.fiscalCode} label={props.labelFiscalCode} />
      <TextInput name="email" disabled={true} value={props.email} label={props.labelEmail} />
      <TextInput name="telephone" disabled={true} label={props.labelTelephone} value={props.telephone} />
      <TextInput name="address" label={props.labelAddress} disabled={true} value={props.address} />
      <div className={accountDataStyles.wrapper}>
        <TextInput
          label={props.labelProvince}
          name="province"
          disabled={true}
          value={props.province}
          className={accountDataStyles.inputSpacer}
        />
        <TextInput
          name="city"
          label={props.labelCity}
          disabled={true}
          value={props.city}
          className={accountDataStyles.inputSpacer}
        />
        <TextInput name="cap" label={props.labelZipCode} disabled={true} value={props.zipCode} />
      </div>
      <hr className={accountDataStyles.divider} />
    </div>
  );
};
